varying vec2 vUv;

void main() {
    vUv = uv;
    // posizione già in clip space grazie alla orthographic camera -1..1
    gl_Position = vec4(position, 1.0);
}